export class ClassCombo {
  public AllDataSource: any[] = [];
  public DataSource: any = [];
  public DisplayExpr: string = "";
  public ValueExpr: string = "";
}
